<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  export default {
    name: 'app',
    components: {
    },
    created: function () {
      this.$router.push('/') // 注意！ 你这个代码的意思就是每次刷新的时候进入'/login'，去掉就可以了
    }
  }
</script>

<style lang="scss">
  *{
    box-sizing: border-box;
    padding: 0;
    margin: 0;
  }
  html,body,#app{
    width: 100%;
    height:100%;
  }
</style>
